import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder,FormControl, FormGroup, Validators } from '@angular/forms';

import { fuseAnimations } from '@fuse/animations';
import { MatDialog, MatDialogRef } from '@angular/material';

import { ContainerModalFormDialogComponent } from '../container-modal/container-modal-form.component';
import { DatePipe } from '@angular/common';
import { AuthService } from 'app/auth.service';
import { Router, Params } from '@angular/router';

@Component({
    selector     : 'home-2-search',
    templateUrl  : './home-search.component.html',
    styleUrls    : ['./home-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})

export class Home2SearchComponent implements OnInit
{
    @Input() seaport;
    @Input() country;
    @Input() unitType;
    @Output() polpoint = new EventEmitter();
    @Output() podpoint = new EventEmitter();
    @Output() submitItem = new EventEmitter();

    filteredCountry1;
    filteredCountry2;
    filteredPort1;
    filteredPort2;
    dialogRef: any;
    errorMessage = '';
    pol;
    pod;
    col;
    cod;
    search = true;
    formSearch = this._formBuilder.group({
        country_of_loading  : ['', Validators.required],
        pol                 : ['', Validators.required],
        country_of_discharge: ['', Validators.required],
        pod                 : ['', Validators.required],
        etd                 : ['', Validators.required],
        type                : ['', Validators.required],
        volume              : [''],
    });
    /**
     * Constructor
     *
     * @param {HomeService} homeService
     */
    constructor(
        private _formBuilder: FormBuilder, 
        private _matDialog: MatDialog,
        private datePipe: DatePipe,
        private authService: AuthService,
        private router: Router
    )
    {
        
    }

    
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.filteredCountry1 = this.country.slice();
        this.filteredPort1 = this.seaport.slice();
        this.filteredCountry2 = this.country.slice();
        this.filteredPort2 = this.seaport.slice();
        this.formSearch.controls.country_of_loading.valueChanges.subscribe(value =>{
            //filter country
            if(value){
                let filterValue = value.toLowerCase();
                this.filteredCountry1 = this.country.filter(item => item.name.toLowerCase().indexOf(filterValue) === 0);
            } else {
                this.filteredCountry1 = this.country.slice();
            }
            this.col = this.country.find(item => item.name == value);
            if(this.col) this.formSearch.controls.pol.setValue('');
        });
        this.formSearch.controls.pol.valueChanges.subscribe(value =>{

            if(this.col) this.filteredPort1 = this.seaport.filter(item => item.country_id == this.col.id);
            //filter port
            if(value != '') {
                let filterValue = value.toLowerCase();
                this.filteredPort1 = this.filteredPort1.filter(item => item.name.toLowerCase().indexOf(filterValue) === 0);
            }
            let port = this.seaport.find(item => item.name == value);
            if(port){
                if(typeof port.info == 'string' && port.info != '') port.info = JSON.parse(port.info);
                if(!this.pod || (this.pod && port.id != this.pod.id)){
                    this.pol = port;
                    this.emitPol(port);
                } else {
                    alert('port exist');
                    this.col = this.country.find(item => item.id == port.country_id)
                    this.formSearch.controls.country_of_loading.setValue(this.col.name);
                }
            }
        });
        this.formSearch.controls.country_of_discharge.valueChanges.subscribe(value =>{
            if(value){
                let filterValue = value.toLowerCase();
                this.filteredCountry2 = this.country.filter(item => item.name.toLowerCase().indexOf(filterValue) === 0);
            } else {
                this.filteredCountry2 = this.country.slice();
            }
            this.cod = this.country.find(item => item.name == value);
            if(this.cod) this.formSearch.controls.pod.setValue('');
        });
        this.formSearch.controls.pod.valueChanges.subscribe(value =>{
            if(this.cod) this.filteredPort2 = this.seaport.filter(item => item.country_id == this.cod.id);
            if(value != '') {
                let filterValue = value.toLowerCase();
                this.filteredPort2 = this.filteredPort2.filter(item => item.name.toLowerCase().indexOf(filterValue) === 0);
            }
            let port = this.seaport.find(item => item.name == value);
            if(port){
                if(typeof port.info == 'string' && port.info != '') port.info = JSON.parse(port.info);
                if(!this.pol || (this.pol && port.id != this.pol.id)){
                    this.pod = port;
                    this.emitPod(port);
                } else {
                    alert('port exist');
                    this.cod = this.country.find(item => item.id == port.country_id)
                    this.formSearch.controls.country_of_discharge.setValue(this.col.name);
                }
            }
        });
    }
    emitPol(pol) {
        this.polpoint.emit(pol);
    }
    emitPod(pod) {
        this.podpoint.emit(pod);
    }
    onSearchSubmit(obj){
        let search = JSON.parse(JSON.stringify(obj.value));
        search.etd = this.datePipe.transform(search.etd, 'MM/dd/yyyy');
        search.polId = this.pol.id;
        search.podId = this.pod.id;
        this.authService.searchData = search;
        if(this.search) this.search = !this.search;
        this.submitItem.emit(search);

/*
        //neu chua dang nhap thi quay ra dang nhap
        if(this.authService.profile == 0){
            search.polObj = this.pol;
            search.podObj = this.pod;
            this.authService.search = search;
            this.authService.goUrl = "/landingpage/result";
            this.router.navigate(['/authentication/login-2']);
        } else {
            this.submitItem.emit(search);
            if(this.search) this.search = !this.search;
        }
        */
    }
    
    openContainerModal(): void
    {
        this.dialogRef = this._matDialog.open(ContainerModalFormDialogComponent, {
            panelClass: 'container-modal-form-dialog',
            data      : {
                action  : 'new',
                unit: this.unitType
            }
        });
        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if ( !response )
                {
                    return;
                }
                let volume = response['volume'];
                let arr = [];
                for(let i = volume.length - 1; i >= 0; i--){
                    if(volume[i].quantity == 0){
                        volume.splice(i, 1);
                    } else {
                        arr.push(volume[i].quantity + 'x' + volume[i].name);
                    }
                }
                arr.sort();
                let string = arr.join(', ');
                this.formSearch.controls.volume.setValue(volume);
                this.formSearch.controls.type.setValue(string);
            });
    }
}